/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _button_filters_fr = new IntlMessageFormat([{ type: 0, value: 'Filtres' }], 'fr');

export function button_filters(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _button_filters_fr.format(args) as unknown as string;
    }

    return _button_filters_fr.format(args) as unknown as string;
}

const _explorer_title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Découvrez le réseau social professionnel Go Africa Online' }],
    'fr',
);

export function explorer_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _explorer_title_fr.format(args) as unknown as string;
    }

    return _explorer_title_fr.format(args) as unknown as string;
}

const _explorer_description_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Le réseau est un des leviers de croissance les plus puissants, qu’il s’agisse de faire progresser une carrière professionnelle ou une entreprise. Posséder des savoirs faire est primordial mais pas suffisant. Aujourd’hui, il est indispensable de le “faire savoir” ! Créez une communauté d’abonnés, publiez des contenus dans votre thématique professionnelle, constituez-vous un réseau d’opportunités sans précédent sur le réseau social professionnel d’Afrique.',
        },
    ],
    'fr',
);

export function explorer_description(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _explorer_description_fr.format(args) as unknown as string;
    }

    return _explorer_description_fr.format(args) as unknown as string;
}

const _explorer_cta_text_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Je m’inscris' }],
    'fr',
);

export function explorer_cta_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _explorer_cta_text_fr.format(args) as unknown as string;
    }

    return _explorer_cta_text_fr.format(args) as unknown as string;
}

const _explorer_cta_small_fr = new IntlMessageFormat(
    [{ type: 0, value: 'gratuitement au réseau' }],
    'fr',
);

export function explorer_cta_small(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _explorer_cta_small_fr.format(args) as unknown as string;
    }

    return _explorer_cta_small_fr.format(args) as unknown as string;
}
